import React, { ReactNode } from "react";

import { Col, Row, Typography } from "components";

type AdminSectionProps = {
  headline: string;
  description?: string;
  extra?: ReactNode;
};

export const AdminSection = ({ headline, description, extra }: AdminSectionProps) => (
  <Row justify="space-around" align="middle">
    <Col sm={24} md={16}>
      <Typography variant="h3" style={{ margin: "1rem 0 0.5rem 0" }}>
        {headline}
      </Typography>
      {description && (
        <Typography variant="paragraph-m" style={{ maxWidth: "768px" }} color="grey-600">
          {description}
        </Typography>
      )}
    </Col>
    <Col sm={24} md={8} className="right">
      <div className="admin-extra">{extra}</div>
    </Col>
  </Row>
);

export default AdminSection;
